import {
  FiFolder, FiStar, FiHeart, FiHome, FiBriefcase, FiShoppingCart,
  FiUsers, FiBarChart2, FiFileText, FiCalendar, FiSettings, FiTarget
} from 'react-icons/fi';

export const itemIcons = {
  folder: FiFolder,
  star: FiStar,
  heart: FiHeart,
  home: FiHome,
  briefcase: FiBriefcase,
  cart: FiShoppingCart,
  users: FiUsers,
  chart: FiBarChart2,
  file: FiFileText,
  calendar: FiCalendar,
  settings: FiSettings,
  target: FiTarget
};
export type ItemIcon = keyof typeof itemIcons;
export const isItemIcon = (value: unknown): value is ItemIcon =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(itemIcons, value);
